<template lang="pug">
  .ProductAndServer
    h1(:class="titleAnimation") 产品与服务
    p(v-show="text") {{ text }}
    div
      .card(v-for="(item, index) in products" :class="[contentAnimation, `animateDelay-${index}`]")
        img(:src="item.img" height="58px")
        h3 {{ item.title }}
        div
          p(v-for="text in item.texts") {{ text }}
</template>

<script>
  import Mixin from "../../index.js";

  export default {
    name: "ProductAndServer",
    mixins: [Mixin],
    props: {
      text: {type: String},
      products: {type: Array},
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .ProductAndServer {
    VStack(center, center)
    padding 100px 0 50px
    position relative
    &::after {
      content ""
      position absolute
      bottom 0
      left 0
      right 0
      top 50%
      background-color #f4f4f4
    }
    > div {
      z-index 1
      HStack(center, center)
      .card {
        width 370px
        height 338px
        background-color white
        VStack(center, flex-start)
        box-shadow 0 12px 40px 0 #eaeaea
        margin 12px
        transition all .3s
        &:hover {
          transform scale(1.1) translate(0, -15px)
        }
        img {
          margin-top 40px
        }
        > h3 {
          font-size 24px
          FontSetting("思源黑体 CN Regular")
          color #000000
          margin-bottom 10px
        }
        p {
          position relative
          padding-left 24px
          margin 10px 30px 0
          line-height 24px
          max-width 300px
          
          &::before {
            position absolute
            top 4px
            left 0
            content ""
            background url("../../../../assets/images/checkmark-circle-outline.png") center no-repeat
            width 14px
            height 14px
            line-height 14px
          }
        }
      }
    }
    @media (max-width ipadProScreenWidth) {
      > div {
        HStack()
        width 100%
        overflow-x auto
        .card {
          flex-shrink 0
        }
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0
      width 100vw
      > div {
        width 100%
        overflow auto
        HStack()
        .card {
          flex-shrink 0
          width 75%
        }
      }
    }
  }
</style>
